/**
 * The client's other two places: paying the fee, and setting up access.
 * Built from the panels the owner's view already uses, so a figure or a
 * connection reads the same in both (one source per figure).
 */
import { PageHeader } from "@/design-system/PageHeader";

import { ClientProfitSettings } from "../identity/AccountPanel";
import { BybitConnectionPanel } from "../identity/BybitConnectionPanel";
import { PoolSelectionPanel } from "../identity/PoolSelectionPanel";
import { FeeBalancePanel } from "../identity/FeeBalancePanel";
import { TelegramPanel } from "../notifications/TelegramPanel";
import { InvitePanel } from "./InvitePanel";
import { LegalDocuments, PasswordPanel } from "../settings/SettingsPage";

export function ClientBilling(): React.JSX.Element {
  return (
    <div className="flex flex-col gap-2" data-testid="client-billing">
      <PageHeader
        title="Пополнения и комиссия"
        description="Комиссия платформы — доля прибыли закрытых сделок. Она списывается с предоплаченного баланса; пополнение — переводом на Bybit по UID."
      />
      <div className="flex max-w-3xl flex-col gap-2">
        <FeeBalancePanel />
        <InvitePanel />
      </div>
    </div>
  );
}

export function ClientSettings({ tenantId, accountId, roles }: {
  readonly tenantId: string; readonly accountId: string; readonly roles: readonly string[];
}): React.JSX.Element {
  return (
    <div className="flex flex-col gap-2" data-testid="client-settings">
      <PageHeader title="Настройки" description="Прибыль и пулы, подключение биржи, уведомления в Telegram, пароль и документы." />
      {/* What the client decides about its own money: the share of profit
          that goes back into trading, recovery buys, and how many slots each
          pool may hold. Every action a client has belongs in its cabinet. */}
      <div className="grid grid-cols-1 items-start gap-2 lg:grid-cols-2">
        <div className="flex min-w-0 flex-col gap-2">
          <ClientProfitSettings tenantId={tenantId} accountId={accountId} />
        </div>
        <PoolSelectionPanel owner={roles.includes("OWNER")} />
      </div>
      <div className="grid grid-cols-1 items-start gap-2 lg:grid-cols-2">
        <BybitConnectionPanel tenantId={tenantId} accountId={accountId} roles={roles} />
        <div className="flex min-w-0 flex-col gap-2">
          {/* The account's owner links and unlinks its own Telegram. */}
          <TelegramPanel owner={roles.includes("OWNER")} />
          <PasswordPanel />
        </div>
      </div>
      <LegalDocuments />
    </div>
  );
}
